
/*---------------------------
:: Navbar on Scroll
-----------------------------*/
$(window).scroll(function(){
  $('header').toggleClass('scrolled', $(this).scrollTop() > 100);
   if ($(this).scrollTop() > 100) {
      $('header').addClass('fixed-top');
    }
    else {
      $('header').removeClass("fixed-top");
    }
});

// academic
document.addEventListener('DOMContentLoaded', function () {
  const dropdownButton = document.getElementById('dropdownMenuButton1');
  const dropdownWrapper = dropdownButton.closest('.dropdown');
  const dropdownMenu = dropdownWrapper.querySelector('.dropdown-menu');

  // Toggle dropdown on button click
  dropdownButton.addEventListener('click', function (e) {
    e.stopPropagation(); // Prevent event bubbling
    dropdownMenu.classList.toggle('show');
    dropdownWrapper.classList.toggle('show');
  });

  // Close on outside click
  document.addEventListener('click', function (e) {
    if (!dropdownWrapper.contains(e.target)) {
      dropdownMenu.classList.remove('show');
      dropdownWrapper.classList.remove('show');
    }
  });

  // Close on browser back navigation
  window.addEventListener('popstate', function () {
    dropdownMenu.classList.remove('show');
    dropdownWrapper.classList.remove('show');
  });

  // Close when program card link is clicked
  const programCardLinks = document.querySelectorAll('.program-card a');
  programCardLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      dropdownMenu.classList.remove('show');
      dropdownWrapper.classList.remove('show');
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
    const accordionItems = document.querySelectorAll('.accordion');

    // Function to handle accordion behavior
    function handleAccordionClick(item) {
        const isActive = item.classList.contains('active');
        const targetId = item.getAttribute('data-bs-target').substring(1);
        const targetBody = document.getElementById(targetId);

        // Remove 'active' and 'show' classes from all accordion items
        accordionItems.forEach(item => {
            item.classList.remove('active');
            const targetId = item.getAttribute('data-bs-target').substring(1);
            const targetBody = document.getElementById(targetId);
            if (targetBody) {
                targetBody.classList.remove('show');
            }
        });

        // Add 'active' and 'show' classes to the clicked item and its target body
        if (!isActive && targetBody) {
            item.classList.add('active');
            targetBody.classList.add('show');
        }
    }

    // Attach click event listener to each accordion item
    accordionItems.forEach(item => {
        item.addEventListener('click', function () {
            handleAccordionClick(this);
        });
    });
    // const routerLinks = document.querySelectorAll('a[href]');
    // const isMobile = window.innerWidth <= 768; // Adjust the value based on your mobile resolution breakpoint

    //     routerLinks.forEach(link => {
    //     link.addEventListener('click', function () {
    //         if (isMobile) {
    //           accordionItems.forEach(item => {
    //               item.classList.remove('active');
    //               const targetId = item.getAttribute('data-bs-target').substring(1);
    //               const targetBody = document.getElementById(targetId);
    //               if (targetBody) {
    //                   targetBody.classList.remove('show');
    //               }
    //           });
    //         }
    //     });
    // });

});


document.addEventListener('DOMContentLoaded', function () {
    const accordionButtons = document.querySelectorAll('.footer-responsive .accordion-button');

    // Add event listeners for accordion buttons
    accordionButtons.forEach(button => {
        button.addEventListener('click', toggleAccordion);
    });

    function toggleAccordion() {
        const collapseId = this.getAttribute('aria-controls');
        const collapse = document.getElementById(collapseId);

        // Toggle the aria-expanded attribute only in mobile view
        if (window.innerWidth <= 768) {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', String(!isExpanded));
        }

        // Toggle the collapse class
        collapse.classList.toggle('show');

        // Close other open accordion items if clicked in mobile view
        if (window.innerWidth <= 768) {
            const openAccordions = document.querySelectorAll('.footer-responsive .accordion-button[aria-expanded="true"]');
            openAccordions.forEach(openAccordion => {
                if (openAccordion !== this) {
                    const openCollapseId = openAccordion.getAttribute('aria-controls');
                    const openCollapse = document.getElementById(openCollapseId);
                    openAccordion.setAttribute('aria-expanded', 'false');
                    openCollapse.classList.remove('show');
                }
            });
        } else {
            // Ensure all accordion items remain open in desktop view
            const accordionItems = document.querySelectorAll('.footer-responsive .accordion-collapse');
            accordionItems.forEach((item) => {
                item.classList.add('show');
                const correspondingButton = document.querySelector(`[aria-controls="${item.id}"]`);
                if (correspondingButton) {
                    correspondingButton.setAttribute('aria-expanded', 'true');
                }
            });
        }
    }

    // Ensure all accordion items are closed by default on mobile, except the first one
    if (window.innerWidth <= 768) {
        const accordionItems = document.querySelectorAll('.footer-responsive .accordion-collapse');
        accordionItems.forEach((item, index) => {
            if (index !== 0) { // Skip the first accordion item
                item.classList.remove('show');
                const correspondingButton = document.querySelector(`[aria-controls="${item.id}"]`);
                if (correspondingButton) {
                    correspondingButton.setAttribute('aria-expanded', 'false');
                }
            }
        });
    } else {
        // Ensure all accordion items remain open in desktop view
        const accordionItems = document.querySelectorAll('.footer-responsive .accordion-collapse');
        accordionItems.forEach((item) => {
            item.classList.add('show');
            const correspondingButton = document.querySelector(`[aria-controls="${item.id}"]`);
            if (correspondingButton) {
                correspondingButton.setAttribute('aria-expanded', 'true');
            }
        });
    }
});

